module.exports = __webpack_public_path__ + "static/media/Equipment-1.e2842b79.jpg";